import React, { useState, useEffect } from "react";
import { Form, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import { Site, Country } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./SiteForm.form";
import "./SiteForm.scss";
import { useLanguage } from "../../../../contexts";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const siteController = new Site();
const countryController = new Country();

export function SiteForm(props) {
  const { close, onReload, site, company } = props;
  const { accessToken } = useAuth();

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [countryOptions, setCountryOptions] = useState([]);

  useEffect(() => {
    countryController.getCountries(accessToken, true).then((countries) => {
      setCountryOptions(countries.map((c) => ({ key: c.code, value: c.code, text: c.name })));
    }).catch(() => {});
  }, [accessToken]);

  const formik = useFormik({
    initialValues: initialValues(site),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue, { setSubmitting }) => {
      try {
        if (!site) {
          formValue.company = company;
          const response = await siteController.createSite(accessToken, formValue);
          if (response.code === 200) {
            toast.success("Formulario enviado correctamente!");
          } else {
            toast.error(`${response.msg}`);
          }
        } else {
          const response = await siteController.updateSite(accessToken, site._id, formValue);
          if (response.code === 200) {
            toast.success("Formulario actualizado correctamente!");
          } else {
            toast.error(`${response.msg}`);
          }
        }
        setTimeout(() => {
          close();
          onReload();
        }, 1000);
      } catch (error) {
        toast.error(`${error.msg ? error.msg : "Error en el servidor intente nuevamente"}`);
      } finally {
        setSubmitting(false);
      }
    },
  });

  function formatCuit(value) {
    const cuit = value.replace(/\D/g, "");
    if (cuit.length <= 2) return cuit;
    if (cuit.length <= 10) return cuit.slice(0, 2) + "-" + cuit.slice(2);
    return cuit.slice(0, 2) + "-" + cuit.slice(2, 10) + "-" + cuit.slice(10, 11);
  }

  return (
    <Form className="site-form" onSubmit={formik.handleSubmit}>
      <Form.Group widths="equal">
        <Form.Input
          label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>}
          name="name"
          onChange={formik.handleChange}
          value={formik.values.name}
          error={formik.errors.name}
        />
        <Form.Input
          label={<label>{t("cuit")} <span style={{ color: "#C0392B" }}>*</span></label>}
          name="cuit"
          onChange={formik.handleChange}
          value={formik.values.cuit ? formatCuit(formik.values.cuit) : ""}
          error={formik.errors.cuit}
          maxLength={13}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Input
          label={<label>{t("phone")} <span style={{ color: "#C0392B" }}>*</span></label>}
          name="phone"
          onChange={formik.handleChange}
          value={formik.values.phone}
          error={formik.errors.phone}
        />
        <Form.Input
          label={<label>{t("address")} <span style={{ color: "#C0392B" }}>*</span></label>}
          name="address"
          onChange={formik.handleChange}
          value={formik.values.address}
          error={formik.errors.address}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Input
          label={<label>{t("email")} <span style={{ color: "#C0392B" }}>*</span></label>}
          name="email"
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
        />
        <Form.Field>
          <label>País</label>
          <Dropdown
            fluid selection clearable
            options={countryOptions}
            value={formik.values.country}
            onChange={(_, { value }) => formik.setFieldValue("country", value)}
            placeholder="Seleccionar país"
          />
        </Form.Field>
      </Form.Group>

      <div className="site-form__actions">
        <button type="submit" disabled={formik.isSubmitting} className="site-form__btn site-form__btn--primary">
          {formik.isSubmitting ? "…" : (!site ? t("save") : t("update"))}
        </button>
        <button type="button" onClick={close} className="site-form__btn site-form__btn--cancel">
          {t("cancel")}
        </button>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={800}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Form>
  );
}
